(function() {
    'use strict';

    angular.module('vobeApp').component('cardPackageSingleDefault', {
        templateUrl: 'app/components/vouchers/card/default/card-package-single-default.html',
        controller: 'CardPackageSingleController',
        controllerAs: '$ctrl',
        bindings: {
            viewLayoutTileDesign : '<',//default or text
            tiles: '<', //3 or 4 or 6
            settings: '<',//current view settings
            appliedPromotionCode: '<',
            channel: '<',
            //voucherObject: '<',
            voucherPoolObject: '<',
            currentProperty: '<',
            currentPropertyGroup: '<',
            shoppingCart: '<',
            openPackageModal: '<',//function
            websiteType: '<',//group or property
            groupCategories: '<',
            propertyCategories: '<',
            onlyFeatured: '<',
        }
    });
})();
